import { Box, Grid, makeStyles } from "@material-ui/core"
import React, { useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from 'react-redux';
import { UnitsContext } from "../../../components/contexts/UnitsContext";
import { AppStateType } from "../../../redux/reducers"
import QuestionTabs from "./QuestionTabs";
import { RenderFacilities } from "./RenderFacilities"
import UnitImagesDialog from "./UnitImagesDialog/UnitImagesDialog";
import { useParams } from "react-router-dom";
import { fetchUnits } from "../../../redux/actions/unitsActions";
import { ImageUploader } from "../../../components/ImageUploader";
import { NoUnitsCard } from "../../../components/NoUnitsCard";
import { ExtraInfo } from "../../../components/ExtraInfo";
import { PlaceholderClassify } from "../../../components/PlaceholderClassify";
import { setFacilities } from "../../../redux/actions/facilitiesActions";
import { getSteps } from "./FacilitiesForm";
import { AccessibilityUnit } from "../../../models/AccessibilityUnits";
import { UnitsType } from "./SelectFacilities";
import {fetchA11yes} from "../../../redux/actions/a11yesActions";

const useStyles = makeStyles((theme) => ({
    boxWrapper: {
        padding: '16px 0 80px',
        height: "100%",
        overflowX: "visible"
    },
    fullHeight: {
        height: "100%"
    },
    boxBackgroundColor: {
        backgroundColor: "#233245"
    },
}))

export const Classify = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const { id } = useParams<{ id: string }>();
    const { existingUnitState, chosenUnitState, currentUnitState } = useContext(UnitsContext)
    const user = useSelector((state: AppStateType) => state.authReducer.user)!
    const units: AccessibilityUnit[] = useSelector((state: AppStateType) => state.unitsReducer.units);
    const property = useSelector((state: AppStateType) => state.propertyReducer.property)!
    const a11yStandardValues = useSelector((state: AppStateType) => state.a11yStandardReducer.a11yStandard)

    const a11yStandard = a11yStandardValues.find((item) => {
        return item.key === property.a11y_standard
    });

    const [, setCurrentUnit] = currentUnitState
    const [existingUnit, setExistingUnit] = existingUnitState
    const [chosenUnit, setChosenUnit] = chosenUnitState
    const [imagesDialog, setImagesDialog] = useState(false)

    useEffect(() => {
        if (property) {
            dispatch(fetchUnits(property.id, user.token))
            // dispatch(fetchA11yes(user.token, property.id))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (units) {
            const removeFacilities = ["Private bathroom", "Private kitchen", "Toilet room (private)"]
            const facilities = Array.from(
              new Set((units.filter((u) => u?.related_to?.length === 0) ?? [])
                .map((item) => item.type).filter(i => i))).filter(unit => {
                    return removeFacilities.indexOf(unit) === -1;
            });
            const allFacilities: UnitsType[] = getSteps(a11yStandard, property);
            const propertyFaclities = allFacilities.filter((facility) => facilities.includes(facility.key)).map((f) => f.key)
            dispatch(setFacilities(propertyFaclities))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [units, a11yStandard]);

    const handleCloseDialog = () => {
        setImagesDialog(false)
    }
    const handleOpenDialog = () => {
        setImagesDialog(true)
    }

    const RenderContent = () => {
        if (existingUnit) {
            return <QuestionTabs existingUnit={existingUnit} units={units} unityIndex={chosenUnit.unityIndex} />
        } else if (units && units.length > 0) {
            return <PlaceholderClassify />
        } else {
            return <NoUnitsCard id={id} />
        }
    }
    return (
        <Box className={classes.boxWrapper}>
            <UnitImagesDialog open={imagesDialog} onClose={handleCloseDialog} unit={existingUnit} />
            <Grid container spacing={2} className={classes.fullHeight} >
                <Grid item xs={12} md={4} lg={3}>
                    <Box className={classes.boxBackgroundColor}>
                        <RenderFacilities
                            property={property}
                            setCurrentUnit={setCurrentUnit}
                            setExistingUnit={setExistingUnit}
                            setChosenUnit={setChosenUnit}
                            a11yStandard={a11yStandard}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={8} lg={7}>
                    <RenderContent />
                </Grid>
                <Grid item xs={12} md={12} lg={2}>
                    {units && units.length > 0 && <ImageUploader handleOpenDialog={handleOpenDialog} existingUnit={existingUnit} />}
                    {existingUnit ? <ExtraInfo existingUnit={existingUnit} /> : null}
                </Grid>
            </Grid>
        </Box>
    )
}
